/**
 * Best-effort redaction of secrets from renderer console text before it leaves
 * the machine in a support report. Emails/usernames are intentionally KEPT
 * (they help support); only credentials/tokens are scrubbed. Mirror of
 * extension/src/utils/scrubSecrets.ts (main-process log scrubbing).
 */

const REDACTED = "«redacted»";

const PATTERNS: { re: RegExp; replace: string }[] = [
  {
    re: /\b(AccessKey|Bearer|Basic)\s+[A-Za-z0-9._~+/=-]{8,}/gi,
    replace: `$1 ${REDACTED}`,
  },
  {
    re: /\beyJ[A-Za-z0-9_-]{5,}\.[A-Za-z0-9_-]{5,}\.[A-Za-z0-9_-]{5,}/g,
    replace: REDACTED,
  },
  {
    re: /("?\b(?:password|passwd|secret|client_secret|token|access[_-]?token|refresh[_-]?token|access[_-]?key|api[_-]?key|apikey|authorization|private[_-]?key)\b"?\s*[:=]\s*"?)[^"\s,}&]+/gi,
    replace: `$1${REDACTED}`,
  },
  {
    re: /([?&](?:access_token|refresh_token|access_?key|code|token|api_key|apikey|key|secret)=)[^&\s"']+/gi,
    replace: `$1${REDACTED}`,
  },
];

export function scrubSecrets(text: string): string {
  if (!text) return text;
  let out = text;
  for (const { re, replace } of PATTERNS) {
    out = out.replace(re, replace);
  }
  return out;
}
